<template>
    <span v-show="this.isCAPSLockOn" class="text-danger m-1 pull-right"
      >{{ translate('warnings.capsOpen') }}</span
    >
</template>

<script>
export default {
  name: "ModifierKeyStateWarning",
  created: function () {
    window.addEventListener("keyup", this.checkModifierState);
  },
  data: () => ({
    isCAPSLockOn: false,
  }),
  methods: {
    checkModifierState(e) {
      if (e.getModifierState("CapsLock")) this.isCAPSLockOn = true;
      else this.isCAPSLockOn = false;
    },
  },
};
</script>